import React from 'react';
import { Table } from 'antd';

const VendorTable = ({ data }) => {
  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      width: 80,
      align: 'center',
      fixed: true,
    },
    {
      title: 'Công Ty Vận Tải',
      dataIndex: 'partnerName',
      align: 'center',
    },
    {
      title: 'Sản Lượng',
      dataIndex: 'contCount',
      align: 'center',
    },
  ];
  return (
    <div>
      <Table
        bordered
        size='small'
        loading={false}
        columns={columns}
        dataSource={data}
        rowKey='id'
        scroll={{
          x: '100%',
          y: 600,
        }}
        pagination={false}
      />
    </div>
  );
};

export { VendorTable };
